<span [ngClass]="class" [hidden]="!text" placement="right"
[ngbPopover]="toolTipText ? popContent : null"
container="body"
triggers="mouseenter:mouseleave">{{text}}</span>

<ng-template #popContent>
  <div>{{ toolTipText }}</div>
</ng-template>
